import { OnChanges, Component, Input, OnInit } from '@angular/core';
import { RenaultAnimationActionDetailSupervisorDTO, RenaultAnimationActionDTO, RenaultAnimationActionResultModel, RenaultAnimationSubactionResultModel } from '../../../models/renault-animation-action-dto';

@Component({
  selector: 'animation-action-result-total',
  templateUrl: './animation-action-result-total.component.html',
  styleUrls: ['./animation-action-result-total.component.scss']
})
export class AnimationActionResultTotalComponent implements OnChanges {

  @Input() model: RenaultAnimationActionDTO;
  @Input() modelDetail: RenaultAnimationActionDetailSupervisorDTO[];
  resultAction: RenaultAnimationActionResultModel;

  constructor() { }

  ngOnChanges() {    
    this.calculateActionResult();
  }

  calculateActionResult() {
    const that = this;
    this.resultAction = {
      Title: this.model.Title,
      TotalRemuneration: 0,
      Subactions: []
    };
    this.modelDetail.forEach(function (actionSupervisor) {
      actionSupervisor.RenaultAnimationSubactions.forEach(function (subaction) {

        if (!that.resultAction.Subactions.some(x => x.Title == subaction.Title)) {
          let subactionResult: RenaultAnimationSubactionResultModel = {
            Title: subaction.Title,
            TotalRemuneration: 0,
            TotalUnits: 0
          };
          that.resultAction.Subactions.push(subactionResult);
        }

        that.resultAction.TotalRemuneration += subaction.TotalPrice;
        let subactionResult = that.resultAction.Subactions.find(x => x.Title == subaction.Title);
        subactionResult.TotalRemuneration += subaction.TotalPrice;
      });

      actionSupervisor.RenaultAnimationSubactionsUser.forEach(function (subactionUser) {
        that.resultAction.TotalRemuneration += subactionUser.SoldTotalPrice;
        let subactionResult = that.resultAction.Subactions.find(x => x.Title == subactionUser.Title);
        subactionResult.TotalRemuneration += subactionUser.SoldTotalPrice;
        subactionResult.TotalUnits += subactionUser.SoldUnits;
      });
    });
  }

}
